import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { NotFoundErrorPageContentSelector } from './NotFoundErrorPageContentSelector';
import { HeroTeaserDto } from 'cpes-common';
import { fetchNotFoundError } from './NotFoundErrorPageSlice';

export function useNotFoundErrorPage(): AbstractContentState<HeroTeaserDto> {
    return useCmsContent(fetchNotFoundError, NotFoundErrorPageContentSelector);
}
